import React from "react";
import { Link } from "react-router-dom";
import { auth } from "../../utils/auth";
import { getLink } from "../../utils/helpers";

const Configuracion = (props) => {
    return (
        <div className='container'>
            <div className='page-header'>
                <h1 className='page-title'>Configuración</h1>
            </div>
            <div className='row'>
                {auth.can("editar-usuarios") && (
                    <div className='col-md-4 conf-link'>
                        <Link to={getLink("/configuracion/usuarios")}>
                            <div className='conf-icon'>
                                <i className='zmdi zmdi-accounts-alt'></i>
                            </div>
                            <div className='conf-title'>Usuarios</div>
                        </Link>
                    </div>
                )}
                <div className='col-md-4 conf-link'>
                    <Link to={getLink("/configuracion/tipos")}>
                        <div className='conf-icon'>
                            <i className='zmdi zmdi-account-box'></i>
                        </div>
                        <div className='conf-title'>Tipos Empleados</div>
                    </Link>
                </div>
                <div className='col-md-4 conf-link'>
                    <Link to={getLink("/configuracion/categorias")}>
                        <div className='conf-icon'>
                            <i className='zmdi zmdi-truck'></i>
                        </div>
                        <div className='conf-title'>Categorías Vehículos</div>
                    </Link>
                </div>
                <div className='col-md-4 conf-link'>
                    <Link to={getLink("/configuracion/asignaciones")}>
                        <div className='conf-icon'>
                            <i className='zmdi zmdi-assignment-check'></i>
                        </div>
                        <div className='conf-title'>Asignaciones</div>
                    </Link>
                </div>
                {auth.can("ver-sucursales") && (
                <div className='col-md-4 conf-link'>
                    <Link to={getLink("/sucursales")}>
                        <div className='conf-icon'>
                            <i className='zmdi zmdi-store'></i>
                        </div>
                        <div className='conf-title'>Sucursales</div>
                    </Link>
                </div>
                )}
                <div className='col-md-4 conf-link'>
                    <Link to={getLink("/configuracion/almacenes")}>
                        <div className='conf-icon'>
                            <i className='fas fa-warehouse'></i>
                        </div>
                        <div className='conf-title'>Almacenes</div>
                    </Link>
                </div>
                <div className='col-md-4 conf-link'>
                    <Link to={getLink("/configuracion/grupos")}>
                        <div className='conf-icon'>
                            <i className='fas fa-tags'></i>
                        </div>
                        <div className='conf-title'>Grupos de Productos</div>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Configuracion;
